import { atom } from "recoil";

const newLevelAtom = atom({
  key: "newLevelState",
  default: false,
});

export default newLevelAtom;
